function initBenefits() {
  var a = new URLSearchParams(window.location.search).get('a') || '1';
  var all = document.querySelectorAll('.benefits-angle');
  all.forEach(function(el) { el.style.display = 'none'; });
  var target = document.querySelector('.benefits-angle[data-angle="' + a + '"]');
  if (target) target.style.display = 'grid';
  else if (all[0]) all[0].style.display = 'grid';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBenefits);
} else {
  initBenefits();
}
